/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ConfirmModalConfigurationModel} from '../../shared/confirm-modal/confirm-modal/models/confirm-modal-configuration.model';
import {AlertNotificationSeverity} from '../../alert-notification-severity.model';

/**
 * Reject modal configuration
 */
const rejectModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Reason for rejection',
    primaryActionTitle: 'Send rejection',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        notes: {
            placeholder: 'Please write your reason to reject...',
            isNotesMandatory: true,
            height: 110,
            maxNumberCharacters: 400,
            labelNotes: 'Please let your colleague know your reason to reject the request.'
        }
    }
};

/**
 * Confirm discard solution
 */
const confirmDiscardSolveModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Confirm',
    primaryActionTitle: 'Stay on solution',
    secondaryActionTitle: 'Discard solution',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        subtitle: `You haven't finished your PNC solution yet! Are you sure you want to discard the solution?`
    }
};

const cancelModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Cancel rejected PNC',
    primaryActionTitle: 'Cancel PNC',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        notes: {
            height: 110,
            isNotesMandatory: true,
            placeholder: 'Please leave a comment with the reason for the cancellation here.',
            maxNumberCharacters: 400,
        },
        manualChecks: {
            title: 'Be aware that:',
            options: ['By cancelling the PNC, you will not be able to withdraw.']
        }
    }
};

const sendEESpecialistModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Send to EE specialist',
    primaryActionTitle: 'Send to EE specialist',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        manualChecks: {
            title: 'Be aware that:',
            options: ['By sending this flash analysis to the EE specialist you will not be able to discard the solution anymore.']
        }
    }
};

/**
 * Variable to export configurations
 */
const partNumberChangesModalConfigurations: {
    reject: ConfirmModalConfigurationModel;
    rejectSolution: ConfirmModalConfigurationModel;
    discardSolve: ConfirmModalConfigurationModel;
    cancel: ConfirmModalConfigurationModel;
    sendEESpecialist: ConfirmModalConfigurationModel;
} = {
    reject: rejectModalConfiguration,
    rejectSolution: rejectModalConfiguration,
    discardSolve: confirmDiscardSolveModalConfiguration,
    cancel: cancelModalConfiguration,
    sendEESpecialist: sendEESpecialistModalConfiguration
};

export default partNumberChangesModalConfigurations;
